//import 'bootstrap-select/dist/css/bootstrap-select.css';
import 'bootstrap-select/dist/js/bootstrap-select';
import $ from 'jquery';
import { groupBy } from 'lodash';
import * as React from 'react';
import { useEffect, useMemo, useRef } from 'react';
const InputValidationMessage = (message) => {
    const self = this;
    return {
        onInvalid: () => {
            if (self.setCustomValidity)
                self.setCustomValidity(message);
        },
        onChange: () => {
            if (self.setCustomValidity)
                self.setCustomValidity('');
        }
    };
};
export function BootstrapSelectPicker(props) {
    var _a;
    const selectRef = useRef(null);
    const groups = useMemo(() => Object.values(groupBy(props.options, o => !props.groupSelector ? 1 : typeof props.groupSelector == 'function' ? props.groupSelector(o) : o[props.groupSelector])), [props.options, props.groupSelector]);
    useEffect(() => {
        if (!selectRef.current)
            return;
        $(selectRef.current).selectpicker({
            liveSearch: props.liveSearch,
            liveSearchStyle: props.liveSearchStyle,
            title: props.title,
        });
        $(selectRef.current).off('changed.bs.select');
        $(selectRef.current).on('changed.bs.select', () => {
            if (props.onChange)
                props.onChange($(selectRef.current).selectpicker('val', undefined));
        });
        $(selectRef.current).selectpicker('refresh');
    }, [selectRef.current, props.options]);
    useEffect(() => {
        if (!selectRef.current)
            return;
        $(selectRef.current).selectpicker('refresh');
    }, [props.disabled, props.required, props.labelSelector, props.valueSelector, props.groupSelector]);
    useEffect(() => {
        if (!selectRef.current)
            return;
        $(selectRef.current).selectpicker('val', props.selected);
        $(selectRef.current).selectpicker('refresh');
    }, [props.selected, selectRef.current]);
    useEffect(() => {
        if (!selectRef.current)
            return;
        if (props.hidden)
            $(selectRef.current).selectpicker('hide');
        else
            $(selectRef.current).selectpicker('show');
    }, [props.hidden]);
    //useEffect(() => {
    //    if (!selectRef.current)
    //        return
    //    $(selectRef.current).selectpicker('refresh')
    //})
    const getOptionValue = (o) => (typeof props.valueSelector == 'function' ? props.valueSelector(o) : o[props.valueSelector]);
    const getOptionLabel = (o) => typeof props.labelSelector == 'function' ? props.labelSelector(o) : o[props.labelSelector];
    const getGroupLabel = (o) => `${(!props.groupLabel ? undefined : typeof props.groupLabel == 'function' ? props.groupLabel(o) : o[props.groupLabel]) || ''}`;
    return (React.createElement("select", Object.assign({ ref: selectRef, required: props.required, disabled: props.disabled }, (props.customValidationMessage ? InputValidationMessage(props.customValidationMessage) : {}), props.selectProps, { className: `${((_a = props.selectProps) === null || _a === void 0 ? void 0 : _a.className) || ''}`.trim(), value: props.selected }),
        props.anyOption ? React.createElement("option", { value: props.anyOption.value }, props.anyOption.label) : null,
        groups.map((group, j, a) => (React.createElement(React.Fragment, { key: j }, a.length > 1 ? React.createElement("optgroup", { key: j, label: getGroupLabel(group[0]) }, group.map((o, i) => React.createElement("option", { key: i, value: getOptionValue(o) }, getOptionLabel(o)))) : React.createElement(React.Fragment, null, group.map((o, i) => React.createElement("option", { key: i, value: getOptionValue(o) }, getOptionLabel(o)))))))));
}
